import {
    FilterOptionsType,
    SET_ADVANCED_CHECKLIST_FILTERS,
    SET_ADVANCED_CHECKLIST_ITEMS,
    SET_ADVANCED_CHECKLIST_SELECTED_FILTERS,
} from './AdvancedChecklist.actions';
export declare type AdvancedChecklistStateType = {
    listItems: any[];
    filtersList: FilterOptionsType[];
    selectedFiltersIDs: string[];
};

export function AdvancedChecklistReducer(state: AdvancedChecklistStateType, action: { type: string; payload: any }) {
    switch (action.type) {
        case SET_ADVANCED_CHECKLIST_ITEMS:
            return {
                ...state,
                listItems: action.payload,
            };
        case SET_ADVANCED_CHECKLIST_FILTERS:
            return {
                ...state,
                filtersList: action.payload,
            };
        case SET_ADVANCED_CHECKLIST_SELECTED_FILTERS:
            return {
                ...state,
                selectedFiltersIDs: action.payload,
            };
    }
    return state;
}
